import { RouteProps } from "react-router";
import Messages from "features/messages/Messages";
import Accounts from 'features/accounts/Accounts';
import EconomicalTariff from "features/economicalTariff/EconomicalTariff";
import InvoiceSimulation from "features/invoiceSimulation/InvoiceSimulation";

const otherRoutes: RouteProps[] = [
  {  path: "/messages", component: Messages },
  {  path: "/accounts", component: Accounts },
  {  path: "/economical-tariff", component: EconomicalTariff },
  {  path: "/invoice-simulation", component: InvoiceSimulation},
];

export default otherRoutes;
